<template>
    <div class="bordered-card bordered-card_secondary gap-10">
        <h4 class="fw-bold">Reports</h4>
        <div class="d-flex gap-10 w-100 flex-md-row flex-column">
            <div v-if="demographicReport" class="bordered-card bordered-card_secondary justify-content-between pdt-25 pdb-25 gap-25 flex-xxl-row flex-wrap">
                <div class="d-flex flex-column align-items-start gap-10 flex-2">
                    <p class="fw-bold">Reports from Fund Office </p>
                    <h6 class="card-title"> Demographic Request Report </h6>
                </div>
                <a class="btn btn-primary plan-modal border-radius-8 pdl-30 pdr-30 w-sm-100 w-fit flex-1" @click.prevent="openModal('smartsearch', null, 'modal-success', null, { DocumentID: demographicReport })">
                    Download
                </a>
            </div>
            <div class="bordered-card bordered-card_secondary justify-content-between pdt-25 pdb-25 gap-25 flex-xxl-row flex-wrap">
                <div class="d-flex flex-column align-items-start gap-10 flex-2">
                    <p class="fw-bold">Submit ACA Mandate Request</p>
                </div>
                <a href="javascript;" @click.prevent="openModal('employer-aca-report', 'Employee Health Coverage Information Request', null, null, null, null, null, { download: '0' })" class="plan-modal btn btn-primary border-radius-8 pdl-30 pdr-30 w-sm-100 w-fit flex-1">
                    Submit
                </a>
            </div>
            <div class="bordered-card bordered-card_secondary justify-content-between pdt-25 pdb-25 gap-25 flex-xxl-row flex-wrap">
                <div class="d-flex flex-column align-items-start gap-10 flex-2">
                    <p class="fw-bold">Download Health Coverage Report </p>
                </div>
                <a href="javascript;" @click.prevent="openModal('employer-aca-report', 'Employee Health Coverage Information Request', null, null, null, null, null, { download: '1' })" class="plan-modal btn btn-primary border-radius-8 pdl-30 pdr-30 w-sm-100 w-fit flex-1">
                    Download
                </a>
            </div>
        </div>
    </div>
</template>

<script lang="ts">
import { ContributionPreview } from '@/interfaces/local';
import { PropType, defineComponent } from 'vue';
import { useModalStore } from '@/stores/modal';
import { useEmployerStore } from '@/stores/employer';

export default defineComponent({
    props: {
        contributions: {
            type: Object as PropType<ContributionPreview | null>,
            required: false
        }
    },
    setup() {
        return {
            openModal: useModalStore().openModal,
            demographicReport: useEmployerStore().dashboard?.DemographicReport
        }
    }
})
</script>